import script from "./SignupModule.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupModule.vue?vue&type=script&setup=true&lang=js"

import "./SignupModule.vue?vue&type=style&index=0&id=1f07c588&lang=scss"

const __exports__ = script;

export default __exports__